import * as React from 'react';
import { canUserAccess } from '../../atoms/allowDenyList';
import { isSuperAdmin } from '../../components_v2/utils';
import { ObjectAction } from '../../web-types/objectActions';

type T = {
	target: ObjectAction,
	target_id?: number,
	target_uuid?: string,
}

type Props = T & {
	children: JSX.Element,
	skip?: boolean,
	fallback?: JSX.Element
}

export function isRestrictedByAllowDenyList(props: T): boolean {
	const admin = isSuperAdmin();
	const canUserAccessF = canUserAccess();
	if (admin) return false;

	return !canUserAccessF(props.target, props.target_id, props.target_uuid);

}

const RestrictedAllowDenyList: React.FunctionComponent<Props> = (props: Props) => {
	const isRestricted = isRestrictedByAllowDenyList(props);

	if (!isRestricted || props.skip) {
		return props.children;
	}

	return props.fallback ?? <></>;
};

export default RestrictedAllowDenyList;
